import Store from '@/store';
import SLSFamiliaComercialCLient from '@/api/sls-familia-comercial.client';

export default class SlsFamiliaComercialService {
  constructor() {
    this.client = new SLSFamiliaComercialCLient();
    this.store = Store;
  }

  async findAll() {
    try {
      const { data, ...pagination } = await this.client.getFamiliaComercial(this.store.getters['slsFamiliaComercial/getFilters']);
      this.store.commit('slsFamiliaComercial/setFamiliasComerciais', data);
      this.store.commit('slsFamiliaComercial/setFilters', pagination);
    } catch (error) {
      console.log(error);
    }
  }

  async findByCodMarca(codMarca) {
    try {
      const data = await this.client.getFamiliaComercialByCodMarca(codMarca);
      this.store.commit('slsFamiliaComercial/setFamiliasComerciais', data);
    } catch (error) {
      console.log(error);
    }
  }
}
